import React, {useContext} from "react";
import {Col, Dropdown, DropdownButton, Row} from "react-bootstrap";
import {AuthContext} from "../../contexts/auth/AuthContext";
import LangSelection from "../LangSelection/LangSelection";
import './StatusBar.css';
import MaxiIcon from "../Maxiicon/MaxiIcon";
import {Link, useNavigate} from "react-router-dom";
import {useIntl} from "react-intl";
import messages from "../../i18n/messages";

const StatusBar = () => {
    const intl = useIntl();
    const navigate = useNavigate();
    const [authContext, setAuthContext] = useContext(AuthContext);

    const onLoginClick = () => {
        // navigate to login page
        navigate('/login');
    }

    const onLogoutClick = () => {
        setAuthContext({
            isAuthenticated: false,
            user: '',
            email: '',
            token: '',
            isAdmin: false,
        });
    }

    return (
        <Row>
            <Col xs={1} sm={1} md={1} lg={1} xl={1} className={'home-icon'}>
                <Link to={'/'}><MaxiIcon iconName={'faHouse'} /></Link>
            </Col>
            <Col xs={11} sm={11} md={11} lg={11} xl={{span: 4, offset: 7}} className={'status-bar'}>
                <DropdownButton
                    title={<MaxiIcon iconName={'faUserCircle'} className={'user-icon'} />}
                    id="dropdown-basic"
                    variant={'link'}
                    className={'user-dropdown'}
                >
                    {authContext.isAuthenticated &&
                        <Dropdown.Item disabled={true}>{authContext.user}</Dropdown.Item>
                    }
                    {authContext.isAuthenticated &&
                        <Dropdown.Divider />
                    }
                    {authContext.isAuthenticated &&
                        <Dropdown.Item onClick={onLogoutClick}>{intl.formatMessage(messages.logoutButtonLabel)}</Dropdown.Item>
                    }
                    {!authContext.isAuthenticated &&
                        <Dropdown.Item onClick={onLoginClick}>{intl.formatMessage(messages.loginButtonLabel)}</Dropdown.Item>
                    }
                </DropdownButton>
                <LangSelection />
            </Col>
        </Row>
    );
}

export default StatusBar;